window.axios = require('axios');

import Vue from 'vue';
import CookieWarning from './components/notice/CookieWarning'
import ConsultationWarning from "./components/notice/ConsultationWarning";
import ConsultationNotice from "./components/notice/ConsultationNotice";
import ErrorMessage from "./components/notifications/ErrorMessage";
import ConfirmMessage from "./components/notifications/ConfirmMessage";
import PromptMessage from "./components/notifications/PromptMessage";
import {Cookie} from "../../utils/Cookie/Cookie";

Vue.use(Cookie);

new Vue({
    el: '#system-notice',
    components: {
        CookieWarning,
        ConsultationNotice,
        ConsultationWarning,
        ErrorMessage,
        ConfirmMessage,
        PromptMessage,
    }
});
